export default function cleanForURL(str) {


    //const pascal = str.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');

    const withoutBadChars = str.replace(/[./\-&]/g, "")
    const kebab = withoutBadChars.split(" ").filter(item => item).join("-");

    return kebab;
}